<template lang="pug">
SocialIconsListDumb(:socialIconsList="getSocialIconsList", :theme="theme")
</template>
<script>
import SocialIconsListDumb from "./SocialIconsListDumb";
export default {
  name: "SocialIconsList",
  components: {
    SocialIconsListDumb,
  },
  props: {
    theme: {
      type: String,
      default: "black", // black, white
    },
  },
  computed: {

    /**
     * [{type: "discord", link: "https://blabla.tm"}, {...}, ...]
     * @returns {[{}]}
     */
    getSocialIconsList() {
      return this.$t("social_icons");
    },
  },
}
</script>
